import React, {ComponentProps} from "react"
import {Meta, Story} from "@storybook/react"
import ModalIncompatibleOs from "@components/molecules/ModalIncompatibleOs"
import sharedLocales from "@locales/views/shared/ja.yml"

type PropTypes = ComponentProps<typeof ModalIncompatibleOs>

export default {
  title: "Molecules/ModalIncompatibleOs",
  component: ModalIncompatibleOs,
} as Meta

const Template: Story<PropTypes> = (args) => <ModalIncompatibleOs {...args} />

export const Default = Template.bind({})
Default.args = {
  data: {
    t: {
      current: sharedLocales.ja.shared.incompatible_os,
    },
  },
}
